import React from "react";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Tooltip from "@mui/material/Tooltip";

import { ArrowDownIcon } from "../../Icons/Icons";
import { isMenuItemActive, isParentMenuItemActive } from "../helpers";

/**
 * Component for rendering the collapsed menu items
 */
export const CollapsedMenuItems = React.memo(
  ({
    menuConfig,
    hoveredItem,
    globalState,
    calculateIsModuleAllowed,
    pathname,
    handleMenuItemHover,
    handleMenuItemLeave,
    handleNavigate,
  }) => {
    return (
      <List>
        {menuConfig.map((item) => {
          if (item.condition && !item.condition(globalState)) {
            return null;
          }

          const path = typeof item.path === "function" ? item.path(globalState) : item.path;
          const IconComponent = item.icon;
          const hasChildren = item.children && item.children.length > 0;
          const isParentActive = hasChildren
            ? isParentMenuItemActive(pathname, item, globalState)
            : isMenuItemActive(pathname, path);

          const isAllowed =
            item.allowedModule === null
              ? item.id === "broker"
                ? item.isBrokerMenuAllowed(globalState)
                : true
              : item.allowedModule === true || calculateIsModuleAllowed(item.allowedModule);

          const isDisabled = item.disabledCheck ? item.disabledCheck(globalState) : !isAllowed;

          return (
            <React.Fragment key={item.id}>
              <Tooltip title={item.text} placement="right" disableHoverListener={hasChildren}>
                <ListItemButton
                  className={`${isParentActive ? "active" : ""} ${hoveredItem?.id === item.id ? "hovered" : ""}`}
                  onClick={hasChildren ? (e) => e.stopPropagation() : () => handleNavigate(path)}
                  disabled={isDisabled}
                  onMouseEnter={(event) => handleMenuItemHover(event, item)}
                  onMouseLeave={handleMenuItemLeave}
                  sx={{
                    minHeight: "48px",
                    paddingX: 1.5,
                    py: 1,
                    borderRightStyle: "solid",
                    borderRightWidth: "6px",
                    borderRightColor: isParentActive ? "secondary.main" : "transparent",
                    "& svg": {
                      transition: "transform 0.2s ease",
                      willChange: "transform",
                    },
                    "&.hovered .collapsed-menu__arrow-icon": {
                      transform: "rotate(-90deg)",
                    },
                  }}
                >
                  {IconComponent && (
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        justifyContent: "flex-start",
                        alignItems: "center",
                        width: "100%",
                        gap: "6px",
                      }}
                    >
                      <IconComponent color={isParentActive && "secondary"} />
                      {hasChildren && (
                        <ArrowDownIcon
                          className="collapsed-menu__arrow-icon"
                          color={isParentActive && "secondary"}
                          sx={{ width: 18, height: 18 }}
                        />
                      )}
                    </ListItemIcon>
                  )}
                </ListItemButton>
              </Tooltip>
            </React.Fragment>
          );
        })}
      </List>
    );
  }
);
